module.exports = __webpack_public_path__ + "c2069b52afa33828179099b60a1bd172.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Aside/images/bio-marc-01.jpg
 ** module id = 358
 ** module chunks = 0
 **/